import { Select } from "antd";
import { useTranslation } from "react-i18next";

import { useAuthorization } from "@/modules/authorization";
import QueryableSelect from "@/modules/queryable-select";

import { getSubjectType } from "./UserRolesSubjectSelect.helper";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const UserRolesSubjectSelect = ({ behavior }) => {
  const { t } = useTranslation();
  const { canManageRole } = useAuthorization();

  const subjectType = getSubjectType(behavior);
  const subjectIsDisabled = !subjectType || !behavior;

  const optionFormatSubject = ({ option, fieldName }) => {
    return (
      <Option
        key={option.id}
        value={option.id}
        data-testid={`option-${fieldName}`}
        disabled={!canManageRole(option)}
      >
        {option.name}
      </Option>
    );
  };

  return (
    <QueryableSelect
      name="subject"
      dataTestId="subject"
      label={t("user:subject")}
      model={subjectType}
      filterBy="name"
      disabled={subjectIsDisabled}
      optionFormat={optionFormatSubject}
      rules={[{ required: !subjectIsDisabled }]}
    />
  );
};

export default UserRolesSubjectSelect;
